import { MutationTree } from 'vuex';
import { ApplicationDirtyStateModel, MStoreConstants, StoreConstants } from '@/types';
import { applicationDirty } from '../applicationDirty';
import { LocalStorage } from '@/utils';

export const mutations: MutationTree<ApplicationDirtyStateModel> = {
  [StoreConstants.ApplicationDirty.Mutations.ResetApplicationDirtyState](state) {
    Object.assign(state, applicationDirty.defaultApplicationDirtyState());
  },
  [StoreConstants.ApplicationDirty.Mutations.SetApplicationDirty](state, isDirty: boolean) {
    state.isDirty = isDirty;
    LocalStorage.emit(MStoreConstants.LocalStorageKeys.IsApplicationDirtyOnAnotherTab, isDirty);
    LocalStorage.set(MStoreConstants.LocalStorageKeys.IsApplicationDirty, isDirty);
  },
  [StoreConstants.ApplicationDirty.Mutations.SetApplicationDirtyOnAnotherTab](state, isDirty: boolean) {
    state.isDirtyOnAnotherTab = isDirty;
    if (!isDirty && state.isDirty) {
      LocalStorage.emit(MStoreConstants.LocalStorageKeys.IsApplicationDirtyOnAnotherTab, true);
      LocalStorage.set(MStoreConstants.LocalStorageKeys.IsApplicationDirty, true);
    }
  },
  [StoreConstants.ApplicationDirty.Mutations.SetApplicationDirtyOnModal](state, isDirty: boolean) {
    state.isDirtyOnModal = isDirty;
  },
  [StoreConstants.ApplicationDirty.Mutations.SetShowApplicationDirtyModal](state, show: boolean) {
    state.showModal = show;
  },
  [StoreConstants.ApplicationDirty.Mutations.SetApplicationDirtyRouteNavigateTo](state, to: any) {
    state.routeNavigatedTo = to;
  }
};
